var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "off",
  "use": "off-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"off\"><path d=\"M11,3H5C2.239,3,0,5.239,0,8s2.239,5,5,5h6c2.761,0,5-2.239,5-5S13.761,3,11,3z M11,12H5c-2.206,0-4-1.794-4-4s1.794-4,4-4  h6c2.206,0,4,1.794,4,4S13.206,12,11,12z\" /><circle cx=\"11\" cy=\"8\" r=\"3\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id